/** Parses comma-separated golden-row keywords, trimming whitespace. */
export function parseGoldenRowKeywords(value: string): string[] {
  return value
    .split(",")
    .map((keyword) => keyword.trim())
    .filter(Boolean);
}

/** Formats golden-row keywords for display in a comma-separated input. */
export function formatGoldenRowKeywords(keywords: string[]): string {
  return keywords.join(", ");
}
